import notifee from '@notifee/react-native';
import { notificationClicked } from './services/notificationService';

notifee.onBackgroundEvent(notificationClicked);